import { RefObject } from 'react';
import { usePageTheme } from '../../../hooks/theme';
import BackgroundImage from '~/app/components/Image/BackgroundImage';
import { useI18n } from '~/app/lib/i18n';

export interface ItemPageBackgroundProps {
  nodeRef: RefObject<HTMLDivElement>;
  height: string;
  width?: string;
  image: string | undefined;
  withMaskGradient: boolean;
}

const BackgroundContainer = ({
  nodeRef,
  width,
  height,
  image,
  withMaskGradient,
}: ItemPageBackgroundProps) => {
  const pageTheme = usePageTheme();
  const { t } = useI18n();

  if (!image) return null;

  return (
    <div
      style={{
        position: 'relative',
        background: pageTheme.backgroundColor,
        overflow: 'hidden',
        height: '100%',
      }}
    >
      <div
        ref={nodeRef}
        style={{
          position: 'relative',
          willChange: 'opacity,transform',
          overflow: 'hidden',
          height,
          width,
        }}
      >
        <BackgroundImage
          testId="backgroundImage"
          src={image}
          alt={t('item.pageBackgroundImageAlt')}
          objectPosition="50% 40%"
          // gradient={gradient}
          fadeInDuration={400}
          imgStyle={{
            filter: 'saturate(.92)',
          }}
          style={{
            WebkitMaskImage: withMaskGradient
              ? `linear-gradient(rgba(0,0,0,0.85) 0%, rgba(0,0,0,0) 100%)`
              : '',
          }}
          withPreload
          coverParent
          cover
        />
      </div>
    </div>
  );
};

export default BackgroundContainer;
